import React, { memo, useState, useEffect, useCallback, useMemo } from "react";
import Button from "../../../shared/components/Button";
import { useDispatch } from 'react-redux';
import { setStoresFilters } from '../../../store/actions/filters';
import ListSimcardToUpload from "./subComponents/ListSimcardToUpload";
import styles from './createSimcard.module.scss';
import WarehouseAfterBatchModal from "../CreateByBatch/WarehouseAfterBatchModal";
import CreateByBash from "../CreateByBatch";
import { useTranslation } from "react-i18next";

const CreateSimcards = ({
    className,
    simcards: {
        submitFetching,
        submitSuccess,
        submitValidateBatchFetching,
        submitValidateBatchSuccess,
        simcardsBatchValidations,
        
    },
    submitSimCardsBatchRequest,
    submitSimcardsValidateBatchRequest,
    setStateSimcards,
    cleanValidatedSimcards,
    patchSimcardsBatchRequest,
}) => {
    const { t } = useTranslation("home");

    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [showWarehouseModal, setShowWarehouseModal] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);

    const showSimcardsToLoad = useMemo(() =>
        Object.keys(simcardsBatchValidations).length > 0
        && (simcardsBatchValidations.available_to_insert.length > 0 || simcardsBatchValidations.unavailable_to_insert.length > 0)
        , [simcardsBatchValidations]);

    const dispatch = useDispatch();

    const handleOpenDialog = () => {
        dispatch(setStoresFilters({ type: ['simcard'], enabled: 'true' }));
        setIsOpenDialog(true);
    };

    const handleContinueToWarehouse = (file) => {
        setPendingFile(file);
        setIsOpenDialog(false); 
        setShowWarehouseModal(true);
    };


    const handleWarehouseClose = () => {
        setShowWarehouseModal(false);
        setPendingFile(null);
        setIsOpenDialog(false); 
    };


    const handleCloseDialog = useCallback(() => {
        setIsOpenDialog(false);
    }, []);

    const setSimcardsToload = () => {
        setStateSimcards({ simcardsBatchValidations: {} });
    }

    useEffect(() => {
        if (submitSuccess) {
            //handleCloseDialog();
        }

        return () => {
            cleanValidatedSimcards();
        }
    }, [submitSuccess, handleCloseDialog, cleanValidatedSimcards]);

    return (
        <div>
            <Button className={styles.buttonImportar} onClick={handleOpenDialog}>
               <span>+</span> Importar Simcards
            </Button>
            {isOpenDialog && (
                <CreateByBash
                    title={t("devices:upload_simcards")}
                    subTitle={t("devices:upload_with_excel_file")}
                    open={isOpenDialog}
                    onClose={handleCloseDialog}
                    submitAction={submitSimCardsBatchRequest}
                    submitValidateBatchAction={submitSimcardsValidateBatchRequest}
                    submitFetching={submitFetching}
                    submitValidateBatchFetching={submitValidateBatchFetching}
                    submitValidateBatchSuccess={submitValidateBatchSuccess}
                    showItemToLoad={showSimcardsToLoad}
                    onChangeFile={setSimcardsToload}
                    onCancelAfterValidate={setSimcardsToload}
                    onSubmitWithWarehouse={(payload, options) => {
                    
                        if (!payload.data?.substatus?.referenceId) {
                            if (options && options._warehouse && options._warehouse._id) {
                                payload = {
                                    ...payload,
                                    data: {
                                        ...payload.data,
                                        substatus: {
                                            ...payload.data.substatus,
                                            referenceId: options._warehouse._id
                                        }
                                    }
                                };
                            }
                        }
                        
                        //return patchSimcardsBatchRequest(payload);
                    }}
                    itemsToLoadAfterValidating={
                        <ListSimcardToUpload
                            itemsAvailableToInsert={simcardsBatchValidations.available_to_insert}
                            itemsUnavailableToInsert={simcardsBatchValidations.unavailable_to_insert}
                        />
                    }
                    type="simcards"

                />
            )}
         
        </div>
    );
};

export default memo(CreateSimcards);
